import React, { ReactElement } from 'react';

import { Flex, Typography } from 'components';

const OpenHP = (): ReactElement => (
  <Flex height="100vh" bg="dark_150" alignItems="center" justifyContent="center">
    <Typography
      type="type6"
      color="white"
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => {
        window.open(
          '/hp',
          'hp',
          'resizable=0, height=375, width=600, left=' + (window.innerWidth - 600) / 2 + ', top=' + (window.innerHeight - 375) / 2
        );
      }}
    >
      Abrir HP
    </Typography>
  </Flex>
);

export default OpenHP;
